<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader :title="$store.state.languages.lang_phrases.kullanicilar"  url="CreateUser" :show_button="true" icon="plus" buttontype="primary" :label="$store.state.languages.lang_phrases.yeni_ekle"></ContentHeader>

<div class="content_card_content">



<SortableTable :data="data" :columns="columns" routename="User" deleteobjectname="user" @dataDeleted="getData"></SortableTable>


</div>





</div>







</div>
</template>

<script>
export default {

  name: 'Users',

  data () {
    return {
    	data:[],
      columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
      },
      {
        type:"text",
        field:"email",
        header:"email",
        hide_on_mobile:true,
      },
      {
        type:"relationarray",
        field:"userroles",
        header:"roller",
        relation_field:"name",
        hide_on_mobile:true,
      },
      {
        type:"date",
        field:"created_at",
        header:"eklenme_tarihi",
        hide_on_mobile:true,
      },

      ],    	
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		this.data = await this.generalApiGet("users")
  	},
  	
  }
};
</script>

<style lang="css" scoped>
</style>